import { AppThunk } from '../../../../../../store/types';
import { BookEffects } from '../../../../../../effects/bookEffects';
import { TBookSettings } from '../../../../../../../common/rest/endlessBook/endlessBookRest';

export class BookSettingsFormEvents {

	public static onRegenerate(bookId: number, settings: TBookSettings): AppThunk {
		return () => BookEffects.regenerate(bookId, settings);
	}

	public static onChangeTranslationLang(bookId: number, nativeLang: string): AppThunk {
		return () => BookEffects.setTranslationLang(bookId, nativeLang);
	}

}
